import { HelpPageCategory } from '../models/helpPageCategory';

const bySortOrder = (a: HelpPageCategory, b: HelpPageCategory) => a.sortOrder - b.sortOrder;

/** Kategorierna i trädets ordning, där underkategorier visas som "Huvudkategori › Underkategori" så det går att se var de hör hemma. */
export const getCategoryOptions = (categories: HelpPageCategory[]): { id: number; name: string }[] => {
  const options: { id: number; name: string }[] = [];
  categories
    .filter((c) => c.parentId === null)
    .sort(bySortOrder)
    .forEach((mainCategory) => {
      options.push({ id: mainCategory.id, name: mainCategory.name });
      categories
        .filter((c) => c.parentId === mainCategory.id)
        .sort(bySortOrder)
        .forEach((subCategory) => {
          options.push({ id: subCategory.id, name: `${mainCategory.name} › ${subCategory.name}` });
        });
    });
  return options;
};

/** Kategorin och dess underkategorier, så att en huvudkategori även visar sidorna som ligger under den. */
export const getCategoryIdsWithChildren = (categories: HelpPageCategory[], categoryId: number): number[] => [
  categoryId,
  ...categories.filter((c) => c.parentId === categoryId).map((c) => c.id),
];
